/**
 * Ao carregar, verifica se a URL contém parâmetros de notificação vinda de push (background).
 * Ex.: /calendar?event=xxx&from_push=1 → adiciona notificação e remove o param.
 */

import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useNotificationsStore } from './model/notificationsStore'

export function NotificationFromPushHandler() {
  const [searchParams, setSearchParams] = useSearchParams()
  const add = useNotificationsStore((s) => s.add)

  useEffect(() => {
    const fromPush = searchParams.get('from_push')
    const eventId = searchParams.get('event')
    if (fromPush !== '1' || !eventId) return

    const title = searchParams.get('title') || 'Lembrete de evento'
    const body = searchParams.get('body') || ''

    add('event_reminder', title, body || undefined, {
      eventId,
      url: `/calendar?event=${encodeURIComponent(eventId)}`,
    })

    searchParams.delete('from_push')
    searchParams.delete('title')
    searchParams.delete('body')
    setSearchParams(searchParams, { replace: true })
  }, [searchParams, setSearchParams, add])

  return null
}
